export default __webpack_public_path__ + "static/media/2.03522bc1.png";